module.exports = __webpack_public_path__ + "img/img20.e6992201.svg";